import React from "react";
import BackgroundDiv from "../misc/elements/BackgroundDiv";

const DetailedAttached = ({ thoughts, focuses, statements, reports }) => {
  const objList = [
    { name: "thought", value: thoughts.value, onClick: thoughts.onClick },
    { name: "focus", value: focuses.value, onClick: focuses.onClick },
    { name: "statement", value: statements.value, onClick: statements.onClick },
    { name: "report", value: reports.value, onClick: reports.onClick },
  ];
  return (
    <div className="divColumn" style={{ width: "100%" }}>
      <div
        className="divRow"
        style={{
          position: "relative",
          padding: "5px",
          justifyContent: "center",
          width: "70%",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: "#4f4f4f",
            borderRadius: ".5rem.5rem 0 0",
            opacity: 1,
          }}
        />
        <div className="textBoldWhite" style={{ zIndex: 1 }}>
          Attached
        </div>
      </div>
      <div
        className="divRow"
        style={{
          width: "73%",
          position: "relative",
          justifyContent: "center",
        }}
      >
        <BackgroundDiv
          backgroundColor={"#9f9f9f"}
          opacity={0.5}
          borderTop={true}
        />
        <div
          className="divRow"
          style={{
            zIndex: 1,
            width: "100%",
            justifyContent: "space-around",
            paddingTop: "5px",
            paddingBottom: "5px",
          }}
        >
          {objList.map((obj, index) => (
            <AttachedHolder
              name={obj.name}
              value={obj.value}
              key={index}
              onClick={obj.onClick}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const AttachedHolder = ({ name, value, onClick }) => {
  return (
    <div
      className="divRow"
      style={{ cursor: "pointer" }}
      onClick={() => onClick(name)}
    >
      <img
        src={`/icons/icon_${name}.png`}
        style={{ objectFit: "contain", height: "35px" }}
      />
      <div
        className="textBoldWhite"
        style={{ marginLeft: "3px", color: "#1f1f1f", fontSize: "20px" }}
      >
        {value}
      </div>
    </div>
  );
};

export default DetailedAttached;
